module.exports = __webpack_public_path__ + "static/media/faber-castell.4bae1404.png";